<template>
  <b-modal
    v-model="show"
    hide-footer
    hide-header
    centered
    size="lg"
    no-close-on-esc
  >
    <transition-group
      name="slide-next"
      tag="div"
      class="tabcontainer"
    >
      <div
        class="row tabitem"
        v-if="step === 1"
        key="1"
      >
        <div class="col-12">
          <div>
            <h4 class="card-title">Jetzt Ihre Autohaus Website buchen!</h4>
            <p class="card-subtitle mb-2 text-muted">Nach Eingabe Ihrer Zahlungsinformationen, haben Sie vollen Zugriff auf Ihre Autohaus Website.</p>
          </div>
        </div>
        <div class="col-6 justify-content-start">
          <b-list-group>
            <b-list-group-item>
              <p class="mb-0">
                <b-icon
                  icon="check-circle"
                  variant="success"
                ></b-icon>
                Optimale Darstellung Ihrer Fahrzeuge
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="mb-0">
                <b-icon
                  icon="check-circle"
                  variant="success"
                ></b-icon>
                SEO optimiert
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="mb-0">
                <b-icon
                  icon="check-circle"
                  variant="success"
                ></b-icon>
                Mehr Traffic auf Ihren Fahrzeuganzeigen
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="mb-0">
                <b-icon
                  icon="check-circle"
                  variant="success"
                ></b-icon>
                Full-Responsive für alle Endgeräte
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="mb-0">
                <b-icon
                  icon="check-circle"
                  variant="success"
                ></b-icon>
                Transparente Preisgestaltung
              </p>
            </b-list-group-item>

          </b-list-group>
        </div>
        <div class="col-6 justify-content-center">
          <b-card
            style="width: 250px"
            class="text-center align-self-center"
          >
            <b-card-text> Ihre Autohaus Website für nur</b-card-text>
            <div>
              <h3>14,99€</h3>
              <sub>mtl. exkl. MwSt.</sub>
            </div>
          </b-card>
        </div>
      </div>

      <div
        class="row tabitem"
        v-if="step === 2"
        key="2"
      >
        <div class="col-12">
          <h4 class="card-title">Kontoinformationen hinterlegen</h4>
          <p class="text-muted">Bitte hinterlegen Sie Ihre Kontoinformationen.</p>

          <div class="row">
            <b-form-group
              label="Kontoinhaber/in *:"
              label-for="input-1"
              class="col-6"
            >
              <b-form-input
                :state="validation.accountHolder"
                v-model="accountHolder"
                type="text"
                required
                ref="test"
                placeholder="z.B. Max Mustermann"
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie einen Kontoinhaber/in an.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="IBAN *:"
              class="col-6"
            >
              <b-form-input
                :state="validation.iban"
                v-model="iban"
                type="text"
                required
                placeholder="z.B. DE12500105170648489890"
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie eine gültige IBAN an.</b-form-invalid-feedback>
            </b-form-group>

            <hr class="col-12" />

            <h6 class="card-title col-12 mt-3">Ihre Rechnungsadresse</h6>

            <b-form-group class="col-12 text-muted">
              <b-form-checkbox v-model="otherBillingAdress">Abweichende Rechnungsadresse</b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Firma *:"
              class="col-6"
              :disabled="!otherBillingAdress"
              label-cols="3"
              :class="{'text-muted': !otherBillingAdress}"
            >
              <b-form-input
                v-model="billingAddress.company"
                type="text"
                required
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Straße *:"
              class="col-6"
              :disabled="!otherBillingAdress"
              label-cols="3"
              :class="{'text-muted': !otherBillingAdress}"
            >
              <b-form-input
                v-model="billingAddress.streetAddress"
                type="text"
                required
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="PLZ *:"
              class="col-6"
              :disabled="!otherBillingAdress"
              label-cols="3"
              :class="{'text-muted': !otherBillingAdress}"
            >
              <b-form-input
                v-model="billingAddress.zipCode"
                type="text"
                required
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Ort *:"
              class="col-6"
              :disabled="!otherBillingAdress"
              label-cols="3"
              :class="{'text-muted': !otherBillingAdress}"
            >
              <b-form-input
                v-model="billingAddress.city"
                type="text"
                required
              ></b-form-input>
              <b-form-invalid-feedback>Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>

            <hr class="col-12" />

            <b-form-group class="col-12 mt-3">
              <b-form-checkbox
                v-model="agbChecked"
                :state="validation.agbChecked"
              >
                Hiermit erkläre ich mich mit den
                <a
                  class="text-primary"
                  target="_blank"
                  href="https://carlisting.de/agb/"
                >AGB</a>
                und
                <a
                  class="text-primary"
                  target="_blank"
                  href="https://carlisting.de/datenschutz/"
                >Datenschutzrichtlinien</a>
                einverstanden.
                <b-form-invalid-feedback :state="validation.agbChecked">Bitte bestätigen Sie die AGB und Datenschutzrichtlinien.</b-form-invalid-feedback>
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-end align-items-center">
          <b-spinner
            type="grow"
            label="Spinning"
            v-if="loading"
          ></b-spinner>
          <small v-if="loading">Kontoinformationen werden gespeichert</small>
        </div>
      </div>

      <div
        class="row align-items-center"
        style="height: 600px"
        v-if="step === 3"
        key="3"
      >
        <div class="col-12 row justify-content-center">
          <h4 class="card-title col-12 text-center">Sie sind jetzt startklar!</h4>
          <p class="text-muted col-6 text-center">Sie können nun fortfahren und Ihre Website konfigurieren oder sofort nutzen.</p>
          <div class="col-12 text-center">
          </div>
        </div>
      </div>
    </transition-group>
    <div class="w-100 d-flex flex-row-reverse align-self-end position-relative">
      <b-button
        variant="primary"
        @click="nextStep()"
        :disabled="loading"
      >Weiter</b-button>
      <!--       <b-button
        variant="primary"
        @click="prevStep()"
        v-if="step > 1"
      >Zurück (dev only)</b-button> -->
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentModal',
  props: ['value'],
  data: () => ({
    step: 1,
    loading: false,
    accountHolder: '',
    iban: '',
    agbChecked: false,
    otherBillingAdress: false,
    billingAddress: {},
    validation: {
      accountHolder: null,
      iban: null,
      agbChecked: null,
    }
  }),

  computed: {
    ...mapState('auth', ['currentUser']),
    show: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
  },

  methods: {
    prevStep () {
      this.step -= 1;
    },
    nextStep () {
      switch (this.step) {
        case 1:
          this.step += 1;
          break;
        case 2:
          this.setup();
          break;
        case 3:
          this.show = false;
          break;
      }
    },
    setStep (step) {
      this.step = step;
    },
    async setup () {

      const allValid = this.validate();
      if (!allValid) return;

      this.loading = true;

      let hasError = false;
      try {
        await this.createPaymentSource();
        if (this.otherBillingAdress) {
          await this.$store.dispatch('auth/updateUser', {
            billingCompany: this.billingAddress.company,
            billingStreetAddress: this.billingAddress.streetAddress,
            billingZipCode: this.billingAddress.zipCode,
            billingCity: this.billingAddress.city,
          });
        }
      } catch (error) {
        console.log(error);
        hasError = true;
      }

      this.loading = false;

      if (!hasError) {
        await this.$store.dispatch('auth/getUser');
        this.$axios.get("/import/vehicles").catch(err => console.log(err));
        this.setStep(3);
      }

    },

    async createPaymentSource () {
      const { source, error } = await this.$stripe.createSource(
        this.accountHolder,
        this.iban,
      );
      if (error) {
        this.$notify({
          title: 'Ungülitge IBAN',
          text: 'Bitte geben Sie eine korrekte IBAN an',
          type: 'error'
        });
        this.validation.iban = false;
        throw error;
      }

      this.source = source.id;
      await this.$store.dispatch('subscription/addSource', this.source);
      await this.$store.dispatch('subscription/getSource');
    },

    validate () {
      let allValid = true;
      Object.entries(this.validation).forEach(([key]) => {
        if (this[key]) {
          this.validation[key] = null;
        } else {
          this.validation[key] = false;
          allValid = false;
        }
      })

      return allValid;
    }
  },

  mounted () {
    this.billingAddress = Object.assign({}, this.currentUser.billingAddress);
  }

}
</script>

<style scoped>
.tabcontainer {
  height: 600px;
  position: relative;
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}
.tabitem {
  position: absolute;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.slide-next-leave-active,
.slide-next-enter-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: 1s;
}
.slide-next-enter,
.slide-next-leave,
.slide-prev-leave-to {
  transform: translate(100%, 0);
}

.slide-next-leave-to,
.slide-prev-enter,
.slide-prev-leave {
  transform: translate(-100%, 0);
}
</style>